import { PaiementTemplate } from "../../model/Model";
import { del, get, post, put } from "../api";

/**
 * Récupère tous les templates de paiements
 */
export async function getPaiementTemplates(): Promise<PaiementTemplate[]> {
    try {
        const response = await get('/v1/paiement-templates');
        return response.data?.data || [];
    } catch (error) {
        console.error('Erreur lors de la récupération des templates de paiements:', error);
        return [];
    }
}

/**
 * Récupère un template de paiement par son ID
 */
export async function getPaiementTemplateById(templateId: number): Promise<PaiementTemplate | null> {
    try {
        const response = await get(`/v1/paiement-templates/${templateId}`);
        return response.data?.data || null;
    } catch (error) {
        console.error('Erreur lors de la récupération du template de paiement:', error);
        return null;
    }
}

/**
 * Crée un nouveau template de paiement
 */
export async function ajouterPaiementTemplate(template: PaiementTemplate): Promise<PaiementTemplate> {
    try {
        const response = await post('/v1/paiement-templates', template);
        return response.data?.data || {};
    } catch (error) {
        console.error('Erreur lors de l\'ajout du template de paiement:', error);
        throw error;
    }
}

/**
 * Modifie un template de paiement existant
 */
export async function modifierPaiementTemplate(template: PaiementTemplate): Promise<PaiementTemplate> {
    try {
        if (!template.id) {
            throw new Error('L\'ID du template est requis pour la modification');
        }
        const response = await put(`/v1/paiement-templates/${template.id}`, template);
        return response.data?.data || {};
    } catch (error) {
        console.error('Erreur lors de la modification du template de paiement:', error);
        throw error;
    }
}

/**
 * Supprime un template de paiement (soft delete)
 */
export async function supprimerPaiementTemplate(templateId: number): Promise<void> {
    try {
        await del(`/v1/paiement-templates/${templateId}`);
    } catch (error) {
        console.error('Erreur lors de la suppression du template de paiement:', error);
        throw error;
    }
}

/**
 * Duplique un template de paiement existant
 */
export async function dupliquerPaiementTemplate(templateId: number): Promise<PaiementTemplate> {
    try {
        const response = await post(`/v1/paiement-templates/${templateId}/duplicate`, {});
        return response.data?.data || {};
    } catch (error) {
        console.error('Erreur lors de la duplication du template de paiement:', error);
        throw error;
    }
}
